import React, { useCallback, useEffect } from "react";
import { toast } from "react-toastify";
import { Container, Row, Col, Spinner } from "reactstrap";
import { API_URL } from "../../config";

const WalletBalance = () => {
  const [currencyData, setCurrencyData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [refreshing, setRefreshing] = React.useState({});
  const [moving, setMoving] = React.useState({});

  const fetchcurrencyData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/api/wallet/getCurrencyBalance`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status) {
        setCurrencyData(data.data);
      } else {
        throw new Error(data.message || "Failed to fetch dashboard data");
      }
    } catch (err) {
      setError(err.message);
      console.error("Error fetching dashboard data:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  // ✅ run once on mount
  useEffect(() => {
    fetchcurrencyData();
  }, [fetchcurrencyData]);

  const HandleRefresh = () => {
    fetchcurrencyData();
  };

  if (error) {
    return (
      <div className="text-center mt-5 text-danger">
        <h5>{error}</h5>
      </div>
    );
  }

  const HandleMove = async (id, coin) => {
    console.log("coin :>> ", coin);
    try {
      setMoving((prev) => ({ ...prev, [id]: true }));

      const resp = await fetch(
        API_URL +
          `${
            coin == "Coin"
              ? "/api/wallet/adminTokenMoveProcess"
              : "/api/wallet/adminTokenMoveProcess"
          }`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({
            currency_id: id,
            basecoin: coin == "Coin" ? "all" : coin,
          }),
        }
      );

      const data = await resp.json();

      if (data?.status) {
        toast.success(data?.message || "Move successful");
      } else {
        toast.error(data?.message || "Failed to move");
      }
    } catch (error) {
      console.error("Error moving token:", error);
      toast.error("Something went wrong while moving");
    } finally {
      setMoving((prev) => ({ ...prev, [id]: false }));
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col>
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 font-size-18">Wallet Balance</h4>
            </div>
          </Col>
        </Row>
        {loading ? (
          <div className="text-center my-5">
            <Spinner color="primary" />
            <p className="mt-2">Loading wallet balances...</p>
          </div>
        ) : error ? (
          <div className="text-center text-danger my-5">
            <p>{error}</p>
          </div>
        ) : (
          <div className="row">
            {currencyData?.map((balance) => (
              <div
                className="col-lg-4 col-md-6 col-sm-12 mb-3"
                key={balance?.currency_id}
              >
                <div className="card border mb-0">
                  <div className="card-body">
                    <div className="d-space-between">
                      <img
                        src={balance?.image}
                        width={30}
                        height={30}
                        alt="currencies"
                      />
                      <h5>
                        {balance?.symbol}-{balance?.basecoin}
                      </h5>
                    </div>

                    <div className="d-space-between mt-3">
                      <p>
                        Bal:{" "}
                        <span style={{ color: "#4169e1", fontWeight: "600" }}>
                          {Number(balance?.balance ?? 0).toFixed(3)}
                        </span>
                      </p>
                      <p>
                        Move:{" "}
                        <span style={{ color: "#4169e1", fontWeight: "600" }}>
                          {balance?.txnCount || 0}
                        </span>
                      </p>
                      <p>
                        24h:{" "}
                        <span style={{ color: "#4169e1", fontWeight: "600" }}>
                          {balance?.dep24Hr || 0}
                        </span>
                      </p>
                      <p>
                        1W:{" "}
                        <span style={{ color: "#4169e1", fontWeight: "600" }}>
                          {balance?.dep1Week || 0}
                        </span>
                      </p>
                    </div>

                    <div className="r-g-3">
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() =>
                          HandleMove(balance.currency_id, balance.basecoin)
                        }
                        disabled={moving?.[balance.currency_id]}
                      >
                        {moving?.[balance.currency_id]
                          ? "Moving..."
                          : "Move Token"}
                      </button>

                      <button
                        className="btn btn-primary btn-sm"
                        disabled={refreshing[balance?.currency_id]}
                        onClick={() => HandleRefresh(balance?.currency_id)}
                      >
                        {refreshing[balance?.currency_id]
                          ? "Refreshing..."
                          : "Refresh"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Container>
    </div>
  );
};

export default WalletBalance;
